import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ez-sso-max-sessions',
  imports: [
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './sso-max-sessions.component.html',
  styleUrls: ['./sso-max-sessions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SsoMaxSessionsComponent {
  cancelHref: string;

  constructor(elementRef: ElementRef) {
    const ssoClientId = elementRef.nativeElement.getAttribute('sso-client-id');

    this.cancelHref = ssoClientId === 'Epic'
      ? '../../epic/error'
      : 'sso-options';
  }
}
